import React, { Fragment } from 'react'

import classNames from 'classnames'
import {
  RelatedContentsList,
  RelatedContentsListVariables,
  ToggleRelatedContentAssociation,
  ToggleRelatedContentAssociationVariables,
} from 'globalTypes'

import { useMutation, useQuery } from '@apollo/client'
import Loading from 'Root/Loader/Page'
import filter from 'lodash/filter'
import map from 'lodash/map'

import styles from './index.module.css'
import QUERY from './related-contents-list.graphql'
import MUTATION from './toggle-related-content-association.graphql'

export interface Props {
  id: any
}

const RelatedContents: React.FC<Props> = ({ id }: Props) => {
  const { data, loading } = useQuery<
    RelatedContentsList,
    RelatedContentsListVariables
  >(QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      id,
    },
  })
  const [mutate, { loading: isMutating }] = useMutation<
    ToggleRelatedContentAssociation,
    ToggleRelatedContentAssociationVariables
  >(MUTATION)

  if (loading) {
    return <Loading />
  }

  const onChange = (objectId: string) => (event) => {
    const checked = event.target.checked

    mutate({
      variables: {
        subjectId: id,
        objectId,
        associated: checked,
      },
    })
  }

  const contents = filter(
    map(data.user?.contents.edges || [], 'node'),
    (node) => node.id !== id
  )
  const isRelated = (id: string) =>
    map(data.content?.relatedContents || [], 'id').includes(id)

  return (
    <Fragment>
      <div className={styles.header}>Contenuti correlati</div>
      <ul className="divide-y divide-gray-200">
        {map(contents, (content) => (
          <li key={content.id} className="p-4">
            <label
              className={classNames(
                {
                  'opacity-50': isMutating,
                },
                styles.label
              )}
            >
              <input
                className={styles.input}
                defaultChecked={isRelated(content.id)}
                onChange={onChange(content.id)}
                type="checkbox"
                disabled={isMutating}
              />
              <span className="ml-4 text-xl">{content.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </Fragment>
  )
}

export default RelatedContents
